<template>
  <BaseModal @backdropClick="$emit('close')">
    <div class="text-center">
      <h2>{{ $t('integrations.iiko_disconnect.title') }}</h2>
      <p class="comment">
        {{ $t('integrations.iiko_disconnect.subtitle') }}
      </p>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/modals/BaseModal.vue";
import IikoAPI from "@/api/iiko";

export default {
  components: {
    BaseModal,
  },
  data() {
    return {
      auth_code: "-----",
    };
  },
  methods: {
    checkStatus() {
      IikoAPI.checkStatus(this.cafe._id)
        .then((data) => {
          if (!data.is_connected) {
            this.$store.dispatch("fetchCafe");
            this.$emit("close");
          } else {
            setTimeout(this.checkStatus, 5000);
          }
        })
        .catch((error) => {
          alert(error);
        });
    },
  },
  mounted() {
    setTimeout(this.checkStatus, 5000);
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
  },
};
</script>

<style>
</style>